import { Link } from "react-router-dom/cjs/react-router-dom";
import promotion from "../assets/dummy/DataRecruit.json";
import { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";

function RecruitJobPosition({ getLink }) {
  const [recruit, getRecruit] = useState(promotion.Recruit.reverse());

  useEffect(() => {
    getLink(window.location.href);
    getRecruit(promotion.Recruit.reverse());
  }, [getLink]);

  const pc = useMediaQuery({
    query: "(min-width : 1024px)",
  });

  return (
    <div className="inner">
      {pc ? (
        <>
          <h2 className="basic-title">채용공고</h2>
          <div className="basic-subtitle">
            헬리오센의 채용 소식을 알려드립니다.
          </div>
          <div className="jobposition-box">
            <ul className="jobposition-list">
              {recruit.map((rec) => (
                <li className="jobposition-item" key={rec.id}>
                  <Link
                    className="jobposition-link"
                    to={`/recruit/jobposition/${rec.id}`}
                  >
                    <b className="jobposition-category">개발</b>
                    <div>
                      <h3 className="jobposition-title">{rec.title}</h3>
                      <div
                        className="jobposition-detail"
                        dangerouslySetInnerHTML={{ __html: rec.detail }}
                      ></div>
                    </div>
                    <b className="jobposition-date">~{rec.date}</b>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </>
      ) : (
        <>
          <h2 className="basic-title">채용공고</h2>
          <div className="basic-subtitle">
            헬리오센의 채용 소식을 알려드립니다.
          </div>
          <div className="jobposition-box">
            <ul className="jobposition-list">
              {recruit.map((rec) => (
                <li className="jobposition-item" key={rec.id}>
                  <Link
                    className="jobposition-link"
                    to={`/recruit/jobposition/${rec.id}`}
                  >
                    <span className="jobposition-link-top">
                      <b className="jobposition-category">개발</b>
                      <b className="jobposition-date">~{rec.date}</b>
                    </span>
                    <h3 className="jobposition-title">{rec.title}</h3>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </>
      )}
    </div>
  );
}

export default RecruitJobPosition;
